// extracted by mini-css-extract-plugin
export default {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__F8Zrt","Question":"ActiveQuiz_Question__wkHBQ"};